import React from 'react'

const OtherJewellery = () => {
  return (
    <div>OtherJewellery</div>
  )
}

export default OtherJewellery